import { Td, Text, Tr } from '@chakra-ui/react';
import { Fragment } from 'react';

import { Category, CostBreakData } from './generateCostBreaks';

export const categoryNameMap: Record<Category, string> = {
  materialCost: 'Material Cost',
  laborCost: 'Labor Cost',
  burdenCost: 'Burden Cost',
  serviceCost: 'Service Cost',
};

export function SequenceRows({ sequences, quotePriceCosts }: CostBreakData) {
  return Object.entries(sequences).map(([sequenceNumber, sequence]) => (
    <Fragment key={sequenceNumber}>
      {/* If no categories, render no cost */}
      {sequence.categories.length === 0 && (
        <Tr>
          <Td verticalAlign="top">{sequenceNumber}</Td>
          <Td colSpan={999}>
            <Text color="mw.grey" opacity="0.5" fontStyle="italic">
              No cost
            </Text>
          </Td>
        </Tr>
      )}

      {sequence.categories.map((category, i) => (
        <Tr key={category}>
          {/* Sequence number; render only on the first row */}
          {i === 0 && (
            <Td verticalAlign="top" rowSpan={sequence.categories.length}>
              {sequenceNumber}
            </Td>
          )}

          <Td>{categoryNameMap[category]}</Td>

          {Object.values(quotePriceCosts).map(
            ({ quotePriceUuid, sequences }) => (
              <Td key={quotePriceUuid}>
                {sequences[sequenceNumber][category]}
              </Td>
            ),
          )}
        </Tr>
      ))}
    </Fragment>
  ));
}
